import React from 'react';
import GetEmailForm from 'Forms/GetEmailForm';
import SentInstructions from './SentInstructions';
import DefaultResetPassword from './DefaultResetPassword';

const ResetPasswordLayout = ({ resetEmailSuccess, inModal, onSubmit, resetEmail }) => {
  const renderBody = () => {
    if (resetEmailSuccess) {
      return <SentInstructions resetEmail={resetEmail} />;
    }

    return <GetEmailForm onFormSubmit={onSubmit} />;
  };

  if (inModal) {
    return renderBody();
  }

  let headerTitle = 'Password Assistance';
  if (resetEmailSuccess) {
    headerTitle = 'Password Reset Request Sent!';
  }

  return <DefaultResetPassword renderBody={renderBody} title={headerTitle} />;
};

export default ResetPasswordLayout;
